// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2qt-u","label":"Labeled_label__32chN","divider":"Labeled_divider__1XPXW"};